import { ViewIds } from '@ardoq/api-types';
import { SvgImageName } from '@ardoq/icons';

const viewIdToSvgImageName: Partial<Record<ViewIds, SvgImageName>> = {
  [ViewIds.BLOCK_DIAGRAM]: SvgImageName.SIMPLE_BLOCK_DIAGRAM,
  [ViewIds.SIMPLE_BLOCK_DIAGRAM]: SvgImageName.SIMPLE_BLOCK_DIAGRAM,
  [ViewIds.MODERNIZED_BLOCK_DIAGRAM]: SvgImageName.SIMPLE_BLOCK_DIAGRAM,
  [ViewIds.FLEXIBLE_BLOCK_DIAGRAM]: SvgImageName.SIMPLE_BLOCK_DIAGRAM,
  [ViewIds.BLOCKS]: SvgImageName.BLOCKS,
  [ViewIds.NETWORK]: SvgImageName.NETWORK,
  [ViewIds.RELATIONSHIPS]: SvgImageName.NETWORK,
  [ViewIds.RELATIONSHIPS_3]: SvgImageName.NETWORK,
  [ViewIds.DEPENDENCY_MAP_2]: SvgImageName.DEPENDENCY_MAP,
  [ViewIds.TIMELINE]: SvgImageName.TIMELINE,
  [ViewIds.BUBBLE]: SvgImageName.BUBBLE,
  [ViewIds.COMPONENT_MATRIX]: SvgImageName.COMPONENT_MATRIX,
  [ViewIds.COMPONENT_MATRIX_2]: SvgImageName.COMPONENT_MATRIX,
};

export const getViewStyleGraphicName = (
  viewId: ViewIds
): SvgImageName | undefined => viewIdToSvgImageName[viewId];
